export const SET_USERS_ERROR = 'SET_USERS_ERROR'
export const CLEAR_USERS_ERROR = 'CLEAR_USERS_ERROR'
export const CURRENT_USER_RECEIVED = 'CURRENT_USER_RECEIVED'
export const FORGOT_PASSWORD_EMAIL_SENT = 'FORGOT_PASSWORD_EMAIL_SENT'
export const CONTACT_US_EMAIL_SENT = 'CONTACT_US_EMAIL_SENT'
export const CURRENT_USER_ROLES_RECEIVED = 'CURRENT_USER_ROLES_RECEIVED'
